import { createFileRoute } from '@tanstack/react-router'
import { PAX } from '@/components/PAX'
import { z } from 'zod'

const paxSearchSchema = z.object({
  search: z.string().optional(),
})

export const Route = createFileRoute('/_auth/pax/')({
  validateSearch: paxSearchSchema,
  component: PAXRoute,
})

function PAXRoute() {
  const { search } = Route.useSearch()

  return <PAX initialSearch={search} basePath="/pax" />
}
